/** Client isolation only. Server membership/RLS remain the authorization boundary. */
export interface SessionScope { owner: string | null; token: string | null; version: number }
let scope:SessionScope={owner:null,token:null,version:0};
export const sessionScope=()=>scope;
export function changeSessionScope(owner:string|null,token:string|null):SessionScope {
 scope={owner,token,version:scope.version+1};return scope;
}
export function captureSession(){const captured=scope;return()=>{if(captured!==scope||!captured.owner)throw new Error('Account changed; reopen this action');};}
